import { Flex, FormControl, Text } from "@chakra-ui/react";
import React, { type FormEvent, useEffect, useState } from "react";
import { submitHubSpotForm, isGdprUser } from "utils";
import { Input } from "ui/inputs";
import * as Sentry from "@sentry/nextjs";
import { Button } from "ui/button";
import Balancer from "react-wrap-balancer";
import { GdprOptIn } from "./gdpr-opt-in";
import { trackNewsletterSignup } from "./event-tracking";

export const eventNewsletterCta = {
  title: (
    <Text textStyle={{ base: "headline1", md: "display3", lg: "display2" }}>
      <Balancer>Sign up for event news and updates</Balancer>
    </Text>
  ),
  description: "",
  actions: <NewsletterForm />,
};

const formId = "f816c4ff-0ea4-4a3b-9081-4da3dd8d6e75";

export function NewsletterForm() {
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [gdprEnabled, setGdprEnabled] = useState<boolean>(false);
  const [gdprOptIn, setGdprOptIn] = useState<boolean>(false);

  async function submitForm(event: FormEvent) {
    const pageUri = window.location.href;
    event.preventDefault();
    setLoading(true);

    trackNewsletterSignup("Events", { email });

    await submitHubSpotForm(formId, { email }, pageUri, gdprEnabled, gdprOptIn);
    setLoading(false);
    setSubmitted(true);
  }

  useEffect(() => {
    setSubmitted(false);
  }, [email]);

  useEffect(() => {
    const fetchAndSetGdprStatus = async () => {
      setGdprEnabled(await isGdprUser());
    };

    fetchAndSetGdprStatus().catch((error) => {
      Sentry.captureException(error);
    });
  }, []);

  return (
    <FormControl as="form" display="flex" flexDir="column" gap="tiny" onSubmit={async (event) => submitForm(event)}>
      <Flex
        flexDir={{ base: "column", md: "row" }}
        justifyContent="center"
        gap="tiny"
        w="100%"
        maxW={{ base: "300px", md: "100%" }}
        mx="auto"
      >
        <Input
          placeholder="Email address"
          w={{ base: "100%", md: "240px" }}
          onChange={(event) => {
            setEmail(event.target.value);
          }}
        />
        <Button
          type="submit"
          disabled={submitted}
          isLoading={loading}
          loadingText="Subscribing..."
          w={{ base: "100%", md: "160px" }}
        >
          {submitted ? "Subscribed" : "Subscribe"}
        </Button>
      </Flex>

      {gdprEnabled && (
        <GdprOptIn
          name="gdpr"
          onChange={() => {
            setGdprOptIn(!gdprOptIn);
          }}
        />
      )}
    </FormControl>
  );
}
